//==========================================================================
//common.js
//==========================================================================

//userAgent
//---------------------------------------------------------
function userAgent() {
  const ua = navigator.userAgent;
  if (
    ua.indexOf('iPhone') != -1 ||
    ua.indexOf('iPod') != -1 ||
    (ua.indexOf('Android') != -1 && ua.indexOf('Mobile') != -1)
  ) {
    //sp
    $('body').addClass('is-view-sp');
  } else if (ua.indexOf('iPad') != -1 || ua.indexOf('Android') != -1) {
    //tab
    $('body').addClass('is-view-tab');
  } else {
    // pc
    $('body').addClass('is-view-pc');
  }
}

//userAgentIE
//---------------------------------------------------------
function userAgentIE() {
  const ua = window.navigator.userAgent.toLowerCase();
  const uaVersion = window.navigator.appVersion.toLowerCase();
  //ie
  if (ua.indexOf('msie') != -1 || ua.indexOf('trident') !== -1) {
    $('body').addClass('is-view-ie');
  }
}

//sprite svg
//---------------------------------------------------------

//menu
//---------------------------------------------------------
function menu() {
  const $menuTrriger = $('.js-menu-trigger');
  const $menuTarget = $('.js-menu-target');
  const $menuBg = $('.js-menu-bg');
  const $menuClose = $('.js-menu-close-trigger');
  let scrollPosition;
  //menuTrriger
  $menuTrriger.on('click', function () {
    if (!$(this).hasClass('is-open')) {
      $menuTrriger.addClass('is-open');
      $menuTarget.addClass('is-open');
      $menuBg.addClass('is-open');
      scrollPosition = $(window).scrollTop();
      $('body').addClass('is-locked').css({ top: -scrollPosition });
    } else {
      menuClose();
    }
  });
  //menuClose
  $menuClose.on('click', function () {
    menuClose();
  });
  //menuClose
  function menuClose() {
    $menuTrriger.removeClass('is-open');
    $menuTarget.removeClass('is-open');
    $menuBg.removeClass('is-open');
    $('body').removeClass('is-locked').css({ top: '' });
    window.scrollTo(0, scrollPosition);
  }
}

//drop down nav
//---------------------------------------------------------
function dropNav() {
  $('.js-drop-nav').hover(function () {
    $(this).toggleClass('is-drop-nav-active');
  });
}

//pagetop
//---------------------------------------------------------
function pagetop() {
  const pagetopTrigger = $('.js-pagetop');
  $(window).on('scroll', function () {
    scrollHeight = $(document).height();
    triggerHeight = pagetopTrigger.height();
    scrollPosition = window.innerHeight + $(window).scrollTop() + triggerHeight;
    footHeight = $('.l-footer').height();
    if (scrollHeight - scrollPosition <= footHeight) {
      pagetopTrigger.removeClass('is-fixed');
    } else {
      pagetopTrigger.addClass('is-fixed');
    }
  });
  pagetopTrigger.click(function () {
    $('body,html').animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });
}

// anker
// ---------------------------------------------------
function anker() {
  const headerHeight = $('.l-header').outerHeight();
  $('.js-anker[href^="#"]').click(function () {
    let href = $(this).attr('href');
    let target = $(href == '#' || href == '' ? 'html' : href);
    let position = target.offset().top - headerHeight;
    $('html, body').animate(
      {
        scrollTop: position,
      },
      500
    );
    return false;
  });
}
function headerFixed() {
  const header = $('.l-header');
  const scrollThreshold = 50; // Adjust this value to determine scroll position

  $(window).scroll(function () {
    const scrolled = $(window).scrollTop() > scrollThreshold;
    header.toggleClass('is-fixed', scrolled);
  });
}

//animation
//---------------------------------------------------------

//accordion
//---------------------------------------------------------
function accordion() {
  $('.js-accordion').on('click', function () {
    $(this).toggleClass('is-active').next().stop().slideToggle(300);
    $(this).parents().toggleClass('is-active');
    return false;
  });
}
function menumobile() {
  let scrollPosition;
  $('.js-menu-sub').click(function () {
    if (!$(this).hasClass('is-open')) {
      $('.js-menu-sub').removeClass('is-open');
      $('.l-header-nav__link').removeClass('is-open');
      $('.l-header-nav-drop').hide();
      $(this).addClass('is-open');
      // scrollPosition = $(window).scrollTop();
      // $('body').addClass('is-locked').css({ top: -scrollPosition });
      $(this).next('.l-header-nav-drop').slideDown();
      $(this).prev('.l-header-nav__link').addClass('is-open');
    } else {
      $(this).removeClass('is-open');
      $('.l-header-nav__link').removeClass('is-open');
      $('.l-header-nav-drop').slideUp();
      // $('body').removeClass('is-locked').css({ top: '' });
      // window.scrollTo(0, scrollPosition);
    }
  });
}
function hashtag() {
  if (window.location.hash) {
    var hash = window.location.hash.substr(1);
    var headerHeight = $('.l-header').outerHeight();
    let href = $(this).attr('href');
    let target = $(href == '#' || href == '' ? 'html' : href);
    let position = target.offset().top - headerHeight;
    $('html, body').animate(
      {
        scrollTop: position,
      },
      500
    );
    // $('body,html').animate(
    //   {
    //     scrollTop: $('#' + hash).offset().top - headerHeight,
    //   },
    //   0
    // );
  }
}
//init
//---------------------------------------------------------
$(function () {
  headerFixed();
  userAgent();
  userAgentIE();
  menu();
  menumobile();
  dropNav();
  pagetop();
  anker();
  accordion();
  // hashtag();
});
$(document).ready(function () {
  $(document).ready(function () {
    $('.top-mv__inner h2 span,.sub-mv-ttl .js-text span').each(function () {
      var text = $(this).text();
      var newText = text.split(' ').join('<br>');
      $(this).html(newText);
    });
  });
});
